<template>
  <div>
    <v-card>
      <v-card-title>Filtros</v-card-title>
      <v-card-text>
        <v-treeview
          v-model="filterItems"
          selectable
          selection-type="independent"
          open-on-click
          transition
          dense
          item-text="descricao"
          item-key="id"
          item-children="etapas"
          return-object
          :items="filterOptions"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="save">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'DashboardFilter',
  props: {
    localStorageKey: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      filterItems: [],
      statusItems: [
        {
          id: 0,
          descricao: 'AGENDADOS',
          ids: ['AGENDADO'],
          etapas: [],
        },
      ],
    }
  },

  computed: {
    ...mapState('patio', [
      'servicosDashboard',
      'dashboardFilters',
      'selectedFilters',
    ]),
    ...mapState('auth', ['empresaAtual']),

    filterOptions() {
      const options = this.servicosDashboard.map((servico) => {
        const _key = servico.descricao
        const etapas = servico.etapas.map((etapa) => ({
          id: `${_key} (${etapa.nome})`,
          descricao: etapa.nome,
          public_ids: etapa.public_ids,
          servico: {
            ids: servico.ids,
            descricao: servico.descricao,
          },
        }))

        return { ...servico, etapas, id: _key }
      })
      return [...this.statusItems, ...options]
    },
  },

  methods: {
    ...mapMutations('patio', ['SET_SELECTED_FILTERS']),

    save() {
      this.$emit('save', this.filterItems)
      this.SET_SELECTED_FILTERS(this.filterItems)
    },
    load() {
      this.SET_SELECTED_FILTERS([])
      if (this.localStorageKey) {
        const storedFilters = localStorage.getItem(
          'DashboardGerenciamentoServico' + this.localStorageKey
        )
        if (storedFilters) {
          this.filterItems = JSON.parse(storedFilters)
        }
      }
    },
  },

  async created() {
    this.load()
    Object.assign(this.filterItems, this.selectedFilters)
  },
}
</script>
